import { EventEmitter, Injectable, Output } from '@angular/core';
import { ReplaySubject } from 'rxjs/internal/ReplaySubject';

@Injectable()
export class DelayMessageService {

    onOpenDelayMessage: ReplaySubject<void> = new ReplaySubject<void>(1);

    onCloseDelayMessage: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor() {

    }

    showDelayMessage() {
        this.onOpenDelayMessage.next();
    }
}
